import { Link, useLocation } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import useDocumentTitle from "../../hooks/useDocumentTitle";

export default function NotFound() {
	const location = useLocation();

	useDocumentTitle("Δεν βρέθηκε η σελίδα");

	return (
		<MainContainer>
			<div className="col-12 text-center errorContainer">
				<img src="/img/errorPageImg.svg" data-uw-rm-alt-original="" alt="" data-uw-rm-alt="SVG" />
				<h1>Δεν βρέθηκε η σελίδα.</h1>
				<p className="errorLink">
					Η σελίδα που αναζητήσατε δεν υπάρχει, επιστρέψτε στην αρχική και δοκιμάστε μια καινούρια αναζήτηση.
				</p>
				<div className="goHomeBtn pb-lg-0">
					<Link
						to={location.pathname.includes("ticket-office") ? "/ticket-office" : "/tickets"}
						className="btn-blue btn btn-primary btn-lg mt-4"
					>
						<span>Επιστροφή στην αρχική σελίδα</span>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							height="1em"
							viewBox="0 0 512 512"
							fill="#ffffff"
							aria-hidden="true"
							focusable="false"
						>
							<path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"></path>
						</svg>
					</Link>
				</div>
			</div>
		</MainContainer>
	);
}
